module.exports = __webpack_public_path__ + "static/media/water.e6b59ee5.jpg";